import styled from 'styled-components';

export const StyledWrapper = styled.div`
    padding: 0 24px;
`;
